import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
})
export class PriceComponent implements OnInit {
  @Input() price = 0.0;
  @Input() color = 'rgba(215, 9, 9, 1)';

  constructor() {}

  ngOnInit(): void {}
}
